/**************************************************
 * Nombre:       Barra_Vertical_Limpia_Funnel
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import Chart from "react-apexcharts";

const Barra_Vertical_Limpia_Funnel = ({ancho, marginTop = 0, height = 'auto', series}) => {
    const seriesD = [
        {
            name: "Conversiones",
            data: series,
        },
    ];

    const options = {
        chart: {
            type: 'bar',
            height: 'auto',
            toolbar: {
                show: false // Oculta el menú de la esquina superior derecha
            }
        },
        colors: [
            '#1E3A8A', // Visitas
            '#2563EB', // Contactos
            '#0284C7', // Prospectos
            '#0D9488', // Leads Calificados
            '#10B981', // Oportunidades
            '#F59E0B', // Ofertas
            '#EF4444'  // Ventas
        ],
        plotOptions: {
            bar: {
                borderRadius: 4,
                horizontal: true,
                barHeight: '100%', // Barras más gruesas
                isFunnel: true,
                distributed: true,
            },
        },
        stroke: {
            width: 2,
            colors: ['#fff']
        },
        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return val; // Muestra únicamente el número dentro de la barra
            },
            style: {
                fontSize: '13px',
                fontWeight: 'bold',
                colors: ['#fff']
            },
            dropShadow: {
                enabled: true,
            },
        },

        xaxis: {
            categories: [
                'Visita Funnel',
                'Termino Video Uno',
                'Termino Video Dos',
                'Termino Video Tres',
                'Lead Captado',
            ],
        },
        legend: {
            show: true, // Muestra la leyenda
            position: 'bottom', // La ubica al final de la gráfica
            horizontalAlign: 'left',
            fontSize: '13px',
            itemMargin: {
                horizontal: 8,
                vertical: 8
            }
        },
    };

    return (
        <Chart
            options={options}
            series={seriesD}
            type="bar"
            width={ancho}
            height={height}
            style={{marginTop: 0, marginBottom: -20}}
        />
    )

}
export default Barra_Vertical_Limpia_Funnel